export function swType(sharedModule) {
  /**
   * # swType
   */
  sharedModule.directive('swType', () => ({
    restrict: 'A',
    require: '^swPad',

    link: function postLink(scope, element, attr, swPadCtrl) {
      const value = attr.swType;

      element.on('click', () => {
        scope.$apply(() => {
          swPadCtrl.type(value);
        });
      });
    },
  }));
}
